import {Injectable, inject} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import {Observable, Subject, throwError} from 'rxjs';
import {LoadingService} from "../services/loading/loading.service";
import {catchError, map} from "rxjs/operators";
import {ActivatedRoute, Params} from "@angular/router";

/**
 * Interceptor on HTTP Request for Loading
 */
@Injectable()
export class HttpLoadingInterceptor implements HttpInterceptor {
  private loadingService = inject(LoadingService);


  /**
   * Intercept on any HTTP Request and sets Loading state
   * @param request an HTTP Request
   * @param next an HTTP Handler
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.interceptRunner(request, next)
  }

  /** URLs that should not trigger the loading indicator (e.g. polling). */
  private readonly excludedUrls = [
    'workflows/instances',
  ];

  /**
   * Intercept on any HTTP Request for Project Analysis and sets Loading state
   * @param request an HTTP Request
   * @param next an HTTP Handler
   */
  interceptRunner(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isExcluded = this.excludedUrls.some(url => request.url.includes(url));
    if (isExcluded) {
      return next.handle(request);
    }

    this.loadingService.setLoading(true, request.url, request.method);
    return next.handle(request)
      .pipe(catchError((err) => {
        this.loadingService.setLoading(false, request.url, request.method);
        // Fehler unverändert weiterwerfen, damit Aufrufer den Response-Body auswerten können
        return throwError(() => err);
      }))
      .pipe(map<HttpEvent<any> | unknown, any>((evt: HttpEvent<any> | unknown) => {
        if (evt instanceof HttpResponse) {
          this.loadingService.setLoading(false, request.url, request.method);
        }
        return evt;
      }));
  }
}
